// extracted by mini-css-extract-plugin
module.exports = {"AboutMe":"AboutMe_AboutMe__xP-ln","aboutHolder":"AboutMe_aboutHolder__1W4pu"};